<template>
    <br />
    <van-cell-group title="" inset>
        <van-field left-icon="user-o" v-model="user.userInfo.realName" label="真实姓名" readonly />
        <van-field left-icon="phone-o" v-model="user.userInfo.phone" label="手机号" readonly />
    </van-cell-group>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"></van-divider>
    <van-form>
        <van-card num="1" :price="productInfo.ProductVo.personFee" :title="productInfo.ProductVo.productName"
            :thumb="productInfo.ProductVo.img" :origin-price="productInfo.ProductVo.allFee">
            <template #desc>
                <div>
                    <p class="text3DIndentation">产品包含：</p>
                    <p class="text2DIndentation">{{ productInfo.ProductVo.descOne }}</p>
                    <p class="text2DIndentation">{{ productInfo.ProductVo.descTwo }}</p>
                    <p class="text2DIndentation">{{ productInfo.ProductVo.descThree }}</p>
                    <p class="text2DIndentation">{{ productInfo.ProductVo.descFour }}</p>
                    <p class="text2DIndentation">{{ productInfo.ProductVo.descFive }}</p>
                    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"
                        dashed></van-divider>
                    <p class="text3DIndentation"> 绑定机构：{{ productInfo.ProductVo.hospName }}</p>
                </div>
            </template>
        </van-card>
        <div style="margin: 16px;">
            <van-button round block type="warning" native-type="submit" @click="payNow">
                确认支付
            </van-button>
        </div>
    </van-form>
</template>
<script>
import { toRefs, reactive, onMounted } from 'vue';
import { postJsSdk } from '../../api/personOrder'
import { getUserInfo } from '../../api/userinfo'
import wx from 'weixin-jsapi';
import request from '../../utils/request';
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
export default {
    setup() {
        const router = useRouter();
        const state = reactive({
            ReturnPayInfoVO: {
                appId: '',
                timeStamp: '',
                nonceStr: '',
                prepayId: '',
                signType: '',
                paySign: '',
            }
        })
        const user = reactive({
            userInfo: {
                hospitalName: '',
                area: '',
                realName: '',
                phone: '',
                age: '',
                gender: '',

            }
        })
        const productInfo = reactive({
            ProductVo: {
                id: '',
                productCode: '',
                productName: '',
                descOne: '',
                descTwo: '',
                descThree: '',
                descFour: '',
                descFive: '',
                hospId: '',
                hospName: '',
                personFee: '',
                allFee: '',
                corporatePay: '',
                img: '',
                tag: '',
                operation: '',
                isCorporate: '',
            }
        })
        const jssdkData = reactive({
            WxJsapiSignature: {
                appId: '',
                nonceStr: '',
                timestamp: '',
                url: '',
                signature: '',
            }
        });
        const payNow = () => {
            console.log('开始支付');
            console.log(jssdkData.WxJsapiSignature);
            wx.config({
                debug: false,
                appId: jssdkData.WxJsapiSignature.appId,
                timestamp: jssdkData.WxJsapiSignature.timestamp,
                nonceStr: jssdkData.WxJsapiSignature.nonceStr,
                signature: jssdkData.WxJsapiSignature.signature,
                jsApiList: ["chooseWXPay"],
            })
            console.log(state.ReturnPayInfoVO.timeStamp);
            wx.ready(function () {
                wx.chooseWXPay({
                    debug: false,
                    appId: state.ReturnPayInfoVO.appId,
                    nonceStr: state.ReturnPayInfoVO.nonceStr,
                    timestamp: state.ReturnPayInfoVO.timeStamp,
                    signType: state.ReturnPayInfoVO.signType,
                    package: state.ReturnPayInfoVO.prepayId,
                    paySign: state.ReturnPayInfoVO.paySign,
                    success(res3) {
                        console.log(res3);
                    },
                    fail(res3) {
                        console.log(res3);
                    },
                })
            })
        }
        const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
        onMounted(() => {
            ulog.UserLog.path = router.currentRoute.value.fullPath;
            console.log("当前页面路径==" + ulog.UserLog.path);
            postUserLog(ulog.UserLog).then(() => {});
            console.log('页面打开')
            getUserInfo().then((res1) => {
                user.userInfo = res1.data.data;
                console.log(res1.data.data);
            })
           request.get('/wxmanager/clentPayV3/jsapiWePay', {
                params: {
                    productCode: router.currentRoute.value.params.productCode
                }
            }).then((res) => {
                state.ReturnPayInfoVO = res.data.data;
                console.log("ReturnPayInfoVO", state.ReturnPayInfoVO );
            })

            request.get('/wxmanager/person/findProductVoByCode', {
                params: {
                    productCode: router.currentRoute.value.params.productCode
                }
            }).then((res) => {
                productInfo.ProductVo = res.data.data;
                console.log("ProductVo", productInfo.ProductVo);
            })
        })
        postJsSdk().then((res1) => {
            jssdkData.WxJsapiSignature = res1.data.data;
            console.log(jssdkData.WxJsapiSignature.appId);
        })
        return {
            jssdkData,
            user,
            productInfo,
            ...toRefs(state),
            payNow,
        }
    }
};
</script>
<style scoped>
.text2DIndentation {
    font-size: 12px;
    text-align: left;
    margin-left: 2em;
}

.text3DIndentation {
    font-size: 12px;
    text-align: left;
    text-indent: 1em;
}
</style>